// extracted by mini-css-extract-plugin
export default {"body":"Logout_body__tTe3U","block":"Logout_block__sbntz","title":"Logout_title__HLfB2","content":"Logout_content__kVc0I"};